// extracted by mini-css-extract-plugin
export default {"outlinedSelect":"PeriodDropdown_outlinedSelect__EhI0G","standardSelect":"PeriodDropdown_standardSelect__5qtcz","selectMenu":"PeriodDropdown_selectMenu__sF0io"};